import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/features/trading-view-advanced-chart/components/TradingViewAdvancedChart.tsx");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
